import React, { useState, useEffect } from 'react';
import { makeStyles, createStyles } from '@material-ui/core/styles';
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@material-ui/core';

import ColorLineText from '../../atoms/Text/ColorLineText';

const useStyles = makeStyles(
  createStyles({
    tableCell: {
      //borderWidth: '1px',
      //borderColor: '#dcdcdc',
      //borderStyle: 'solid',
      padding: '0px',
      borderBottomWidth: '0px',
    },
  })
);

type Props = {
  itemName: string;
  color: string;
  isCheckd: boolean;
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
};

const PhaseCurrentCheckBox: React.FC<Props> = (props) => {
  const classes = useStyles();
  return (
    <table>
      <tr>
        <td style={{ padding: '0px 10px 0px 0px' }}>
          <input type="checkbox" onChange={(e) => props.onChange(e)} checked={props.isCheckd} />
          {props.itemName}
        </td>
      </tr>
      <tr>
        <td style={{ padding: '0px 10px 0px 0px' }}>
          {props.color != '' ? <ColorLineText color={props.color} width={'60px'} height={'2px'} /> : <div>&nbsp;</div>}
        </td>
      </tr>
    </table>
  );
};

export default PhaseCurrentCheckBox;
